var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventSupportImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 279.82 267.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eee;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #cbc3e6;\n      }\n\n      .cls-8 {\n        fill: #ccc;\n      }\n\n      .cls-8, .cls-9 {\n        stroke: #5236ab;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.37px;\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient);\n        opacity: .5;\n      }\n\n      .cls-4 {\n        fill: #777;\n      }\n\n      .cls-5 {\n        fill: #5236ab;\n      }\n\n      .cls-6 {\n        fill: #128354;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-9 {\n        fill: #999;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -10588.34,
    cy: 1038.81,
    fx: -10588.34,
    fy: 1038.81,
    r: 73.1,
    gradientTransform: "translate(-14224.14 100.74) rotate(-180) scale(1.36 -.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustrations"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M182.21,230.33h-91.2c-7.9,0-13.63-4.5-14.97-11.77L155.24,7.36,263.29.93c7.71,3.89,10.42,13.17,6.87,23.47l-65.03,188.24c-3.38,9.77-13.63,17.69-22.91,17.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M184.25,223.66h-101.65c-5.29,0-8.01-4.51-6.09-10.08L146.58,10.77c1.92-5.57,7.77-10.08,13.05-10.08h101.65c5.29,0,8.01,4.51,6.09,10.08l-70.07,202.81c-1.92,5.57-7.77,10.08-13.05,10.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "258.72 17.66 194.28 204.18 84.13 204.18 148.57 17.66 258.72 17.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "202.64 131.75 195.6 152.14 118.77 152.14 125.81 131.75 202.64 131.75"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.44,15.57l-.72,2.08h-110.15s.72-2.08.72-2.08c1.92-5.57,7.77-10.08,13.05-10.08h91.01c5.29,0,8.01,4.51,6.09,10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.28,204.18l-.38,1.1c-1.92,5.57-7.76,10.08-13.05,10.08h-91.01c-5.28,0-8.01-4.51-6.09-10.08l.38-1.1h110.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.2,163.33c-.69,1.99-2.78,3.6-4.66,3.6h-48.94c-1.89,0-2.86-1.61-2.17-3.6.69-1.99,2.78-3.6,4.66-3.6h48.94c1.89,0,2.86,1.61,2.17,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168.72,172.48c-.69,1.99-2.78,3.6-4.66,3.6h-30.29c-1.89,0-2.86-1.61-2.17-3.6.69-1.99,2.78-3.6,4.66-3.6h30.29c1.89,0,2.86,1.61,2.17,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M212.95,83.41c-6.49,17.83-26.2,32.29-44.03,32.29-17.83,0-27.02-14.45-20.53-32.29,6.49-17.83,26.2-32.29,44.03-32.29,17.83,0,27.02,14.45,20.53,32.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M204.92,69.26c-1.02-1.61-3.63-1.61-5.82,0l-22.58,16.73c-.94.69-2.06.69-2.5,0l-5.77-9.07c-1.02-1.61-3.63-1.61-5.82,0-2.19,1.61-3.14,4.21-2.12,5.82l9.16,14.39c.3.48.86.71,1.49.68.62.02,1.34-.2,1.99-.68l29.84-22.05c2.19-1.61,3.14-4.21,2.12-5.82Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 139.91,
    cy: 256.96,
    rx: 139.91,
    ry: 10.71
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventSupportImage);
export default __webpack_public_path__ + "static/media/eventSupportImage.a5cc5c68bed74a0061e42113a3075e2e.svg";
export { ForwardRef as ReactComponent };